import React from 'react';
import { Formik, Form } from 'formik'
import CustomTextField from '../forgot-password/CustomTextField'
import CustomButton from '../forgot-password/CustomButton'
import { Typography } from '@material-ui/core';

export default function RegisterTuteeForm({ email, phoneNumber, name,  onSubmit, onSuccess, onFailure }) {

  
  const [firstName="", lastName=""] = !!name ? name.split(" "): ["",''];
  const isFeatureValidated = false
  return <div>
    {
      !!name && isFeatureValidated && <Typography variant="h5" align="center" style={{ textAlign: 'center', margin: '24px 0 24px 0'}}>
      Bienvenue {firstName} !
    </Typography>
    }
    <Typography variant="h5" align="center" style={{ textAlign: 'center', margin: '24px 0 32px 0'}}>
    Créer mon compte
    </Typography>
    <Formik
    enableReinitialize={true}
      initialValues={{
        email,
        firstName,
        lastName,
        phoneNumber,
        password: '',
      }}
      validate={(values) => {
        const errors = {}

        if (!values.email) {
          errors.email = 'Votre email est nécessaire'
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
          errors.email = 'Email Incorrect'
        }
        if (!values.firstName) {
          errors.firstName = 'Votre prénom est nécessaire'
        }

        if (!values.lastName) {
          errors.lastName = 'Votre nom est nécessaire'
        }

        if (!values.phoneNumber) {
          errors.phoneNumber = 'Votre numéro de téléphone est nécessaire'
        } else if (!/^(0)([1-9]){1}([\d]){8}$/i.test(values.phoneNumber)) {
          errors.phoneNumber = 'Numero de téléphone invalide'
        }

        if (!values.password) {
          errors.password = 'Votre mot de passe est nécessaire'
        }

        if (values.password.length < 8) {
          errors.password = 'Votre mot de passe doit contenir au minimum 8 caractères'
        }

        return errors
      }}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(true)
        onSubmit(values)
          .then((data) => {
            setSubmitting(false);
            onSuccess(values);
          })
          .catch((error) => {
            setSubmitting(false);
            onFailure(error);
          });
      }}
    >
      {({ submitForm, isSubmitting }) => (
        <Form>
          <CustomTextField
            name="firstName"
            placeholder="Prénom"
            type="text"
            required
          />
          <CustomTextField
            name="lastName"
            placeholder="Nom"
            type="text"
            required
          />
          <CustomTextField
            name="phoneNumber"
            placeholder="Téléphone"
            type="text"
            required
          />
          <CustomTextField
            name="email"
            placeholder="Adresse email"
            type="email"
            required
          />
          <CustomTextField
            name="password"
            placeholder="Mot de passe"
            type="password"
            required
          />
          <Typography style={{ margin: '16px 0 24px 0' }}>
              En créant un compte, vous acceptez les{' '}
              <a target="_blank" href="/conditions-generales" style={{ color: '#AF1318' }}>
                Conditions générales
              </a>{' '}
              de Clevermate.
          </Typography>
            <CustomButton
            color="secondary"
            onClick={submitForm}
            disabled={isSubmitting}
          >
            CONTINUER
          </CustomButton>
          <Typography style={{ textAlign: 'center', color: '#4c5052', marginTop: 20 }}>
            Vos données sont protégées.
          </Typography>
        </Form>
      )}
    </Formik>
  </div>;
}
